(async function ($) {
  // set language of dayjs to German
  dayjs.locale("de")

  const ortPrettyNameMap = {
    Buergel: "Bürgel",
    Bieber: "Bieber",
    Lauterborn: "Lauterborn",
  };

  const updateTodaysUnterricht = async () => {
    const $unterrichtInfo = $(".nav-unterricht-info");
    const nextUnterrichten = await getNextUnterrichten();
    $unterrichtInfo.html(
      generateUnterrichtenHTMLString(nextUnterrichten, locations)
    );
  }

  const desktopView = window.matchMedia('(min-width: 1025px)')

  const initHTML = (todaysUnterrichten, locations) => {
    const $mainHeader = $("body > header");
    $mainHeader.append("<div class='nav-unterricht-info'></div");
    const $unterrichtInfo = $(".nav-unterricht-info");

    if (desktopView.addEventListener) {
      desktopView.addEventListener('change', updateTodaysUnterricht)
    } else {
      desktopView.addListener('change', updateTodaysUnterricht)
    }

    $unterrichtInfo.html(
      generateUnterrichtenHTMLString(todaysUnterrichten, locations)
    );
  };

  const startUpdateLoop = () => {
    window.unterrichtDisplayInterval = setInterval(updateTodaysUnterricht, 10000);
  };

  const generateUnterrichtenHTMLString = (todaysUnterrichten, locations) => {
    let htmlString = "";
    const uByLoc = groupBy(todaysUnterrichten, "l_name");

    for (const { name: loc } of locations) {
      const prettyName = ortPrettyNameMap[loc];
      const abr = desktopView.matches ? prettyName : prettyName.substring(0, 2).toUpperCase();
      htmlString += `<div><strong>${abr}</strong>: `;

      const unterrichten = uByLoc[loc];
      if (unterrichten) {
        htmlString += unterrichten
          .map((u) => `<span>${unterrichtToMessageEntry(u)}</span>`)
          .join(" | ");
      } else {
        htmlString += "Keine Unterrichtung in den kommenden Tagen";
      }

      htmlString += "</div>";
    }

    return htmlString;
  };

  const isToday = (date) => {
    const today = new Date()
    return date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear()
  }

  const createLink = (link, text) => {
    const linkStyle = "text-decoration: underline; color: white;"
    return `<a style="${linkStyle}" href="https://fahrschule-philipp.com${link}">${text}</a>`
  }

  const unterrichtToMessageEntry = (u) => {
    if (u.type === "intensivkurs") {
      const dayAndDate = dayjs(u.start_time).format("dd DD.MM")
      return `${dayAndDate} Intensivkurs (siehe ${createLink("/termine", "Termine")})`
    }

    const startDate = new Date(u.start_time)
    const today = isToday(startDate)

    const startTime = today ? formatTime(u.start_time) : formatDateAndTime(u.start_time)
    const endTime = formatTime(u.end_time)

    const motorradIndicator = u.type === "motorrad" ? "(A)" : ""

    return `${today ? 'Heute ' : ''}${startTime} - ${endTime} Thema ${u.t_name} ${motorradIndicator}`;
  };

  const formatDateAndTime = (timeString) => {
    const dayjsDate = dayjs(timeString)
    const yearOfOther = dayjsDate.get("year")
    const currentYear = dayjs().get("year")

    // if the timestamp is not the current year show the year
    return dayjsDate.format(
      currentYear !== yearOfOther ? "DD.MM.YYYY HH:mm" : "dd DD.MM HH:mm"
    );
  }

  const formatTime = (timeString) => dayjs(timeString).format("HH:mm")

  const groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  function getNextUnterrichten() {
    return fetch("/wp-json/fp/v1/unterricht/next").then((e) => e.json());
  }

  function getLocations() {
    return fetch("/wp-json/fp/v1/location").then((e) => e.json());
  }

  const nextUnterrichten = await getNextUnterrichten();
  const locations = await getLocations();

  // sort alphabetically
  locations.sort((a, b) => {
    if(a.name < b.name) { return -1; }
    if(a.name > b.name) { return 1; }
    return 0;
  });

  $(function () {
    initHTML(nextUnterrichten, locations);
    startUpdateLoop(locations);
  });
})(jQuery);
